import { FETCH_SELECTED_MONTH_RANGE } from '@/store/common/mutation-type'
import { computed, getCurrentInstance, ref } from '@vue/composition-api'
import moment from 'moment'

function useSelectMonthRange (storeKey) {
    const vm = getCurrentInstance().proxy
    const store = vm.$store
    const monthOptions = computed(() => store.getters[`${storeKey ? storeKey + '/' : ''}monthRange`])
    const minDate = computed(() => store.getters[`${storeKey ? storeKey + '/' : ''}minDate`])
    const maxDate = computed(() => store.getters[`${storeKey ? storeKey + '/' : ''}maxDate`])
    const monthRangeModel = ref('')
    const selectedMonthRange = computed(() => store.getters[`${storeKey ? storeKey + '/' : ''}selectedMonthRange`])
    const handleSelectMonthRange = (value) => {
        const duration = moment.duration({ 'months': 1 })
        const monthRangeArr = []
        let min = moment(value[0], 'YYYY-MM')
        const maxDate = moment(value[1], 'YYYY-MM')
        for (let i = 0; min <= maxDate; i++) {
            monthRangeArr.push(min.format('YYYY-MM'))
            min = min.add(duration)
        }
        selectMonthRange(monthRangeArr)
    }
    const selectMonthRange = value => {
        store.commit(`${storeKey}/${FETCH_SELECTED_MONTH_RANGE}`, value)
    }
    return {
        handleSelectMonthRange,
        selectedMonthRange,
        selectMonthRange,
        monthRangeModel,
        monthOptions,
        minDate,
        maxDate
    }
}

export default useSelectMonthRange
